export const environment = {
  production: false,
  API_HOST: 'server',
  encryptionEnabled: false,
  EncryptionKey: '',
  mqttUserName: '',
  mqttPassword: '',
  loginEncryptionKey: '',
  sessionCheckTimer: 300000
};
